(() => {
  'use strict';
  const desktop = window.matchMedia('(min-width: 901px)');
  let cleanupMenu = () => {};
  function focusDestination(element) {
    const hadTabindex = element.hasAttribute('tabindex');
    if (!hadTabindex) {
      element.setAttribute('tabindex', '-1');
      element.addEventListener('blur', () => element.removeAttribute('tabindex'), { once: true });
    }
    element.focus({ preventScroll: true });
  }
  function initMenu() {
    cleanupMenu();
    const header = document.querySelector('[data-soily-header]');
    const button = header?.querySelector('.menu-button');
    const menu = header?.querySelector('#mobile-menu');
    if (!button || !menu) return;
    const events = new AbortController();
    const listen = (target, type, callback) => target.addEventListener(type, callback, { signal: events.signal });
    function close(restoreFocus = false) {
      menu.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      if (restoreFocus) button.focus({ preventScroll: true });
    }
    button.hidden = false;
    close();
    listen(button, 'click', () => {
      if (!menu.hidden) close();
      else { menu.hidden = false; button.setAttribute('aria-expanded', 'true'); }
    });
    listen(menu, 'click', event => {
      const link = event.target.closest('a');
      if (!link) return;
      close();
      const destination = new URL(link.href, location.href);
      if (destination.origin !== location.origin || destination.pathname !== location.pathname || !destination.hash) return;
      const target = document.getElementById(decodeURIComponent(destination.hash.slice(1)));
      if (target) focusDestination(target);
    });
    listen(document, 'keydown', event => {
      if (event.key === 'Escape' && !menu.hidden) { event.preventDefault(); close(true); }
    });
    listen(document, 'click', event => {
      if (!menu.hidden && !menu.contains(event.target) && !button.contains(event.target)) close();
    });
    listen(document, 'focusin', event => {
      if (!menu.hidden && !menu.contains(event.target) && !button.contains(event.target)) close();
    });
    const resize = () => {
      if (desktop.matches) {
        if (menu.contains(document.activeElement)) header.querySelector('.wordmark')?.focus({ preventScroll: true });
        close();
      }
    };
    desktop.addEventListener('change', resize);
    cleanupMenu = () => { events.abort(); desktop.removeEventListener('change', resize); };
  }
  initMenu();
  const message = document.querySelector('[data-soily-form-message]');
  if (message) message.focus();
  document.addEventListener('shopify:section:load', event => {
    if (event.target.matches('[data-soily-header]') || event.target.querySelector('[data-soily-header]')) initMenu();
  });
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.matches('[data-soily-header]') || event.target.querySelector('[data-soily-header]')) cleanupMenu();
  });
})();
